import NImages from './nimages'
export default NImages;